<template>
  <Select
    :items="processos"
    :selectedItem="filter.processo"
    label="Processo"
    searchPlaceholder="Buscar processo"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        processo: {
          id: "",
          name: "",
        },
      },
      processos: [],
    };
  },
  methods: {
    atualizar(processo) {
      this.filter.processo = processo;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.processo.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.processo.id
      });
    },
  },
  mounted() {
    this.$api.get('/processos', {
      params: {
        build_select: true,
      }
    }).then(response => {
      this.processos = response.data.processos.map(processo => ({
        id: processo.id,
        name: processo.codigo
      }));
      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.processos, this.filter.processo);
    });
  },
}
</script>
